import { asyncAction, action } from 'now-frontend-shared/utils/actions';

// async actions
export const getPropertyBids = asyncAction('propertyBidsList/GET_PROPERTY_BIDS');
export const setListingWinner = asyncAction('propertyBidsList/SET_LISTING_WINNER');

// sync actions
export const clearState = action('propertyBidsList/CLEAR_STATE');
